import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SecurityModule, ApiModule, EnviromentModule, AuthInterceptor, CommonAppModule, SecurityAuth0Module, SecurityModuleConfig, EnviromentModuleConfig } from 'common';
import { ContainerModule } from '../container/container.module';
import { MasterModule } from '../master/master.module';
import { OrderModule } from '../order/order.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NavigationModule } from '../navigation/navigation.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { PackageModule } from '../package/package.module';
import { DeliveryActionsModule } from '../delivery-actions/delivery-actions.module';
import { PrintModule } from '../print/print.module';
import { ElectronModule } from '../electron/electron.module';
import { DocumentModule } from '../document/document.module';
import { ConfigModule } from '../config/config.module';
import { environment } from 'src/environments/environment';
import { SecurityModule as LocalSecurityModule } from '../security/security.module';

// export function fetchBuildDetails(upToDateBuildService: UpToDateBuildService) {
//   return () => {
//     upToDateBuildService.buildIsUpToDate.subscribe(isUpToDate => {
//       if (!isUpToDate) {
//         console.log('Build is not up to date');
//       }
//     });
//   }
// }
const configSecurtiy: SecurityModuleConfig = {
  postAuthUrls: '/security/backend/login',
  logoutRedirectUri: `${window.location.origin}/#/manage/packingStation`,
  loginUrl: '/security/login',
  postLoginBackendUrl: '/manage/packingStation'
};

const configEnviroment : EnviromentModuleConfig = {
  initUrl: '/manage/packingStation'
};

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CommonAppModule,
    ElectronModule.forRoot(),
    PrintModule.forRoot(),
    ApiModule.forRoot(environment.apiServer, environment.apiProtocol),
    SecurityModule.forRoot(configSecurtiy),
    LocalSecurityModule.forRoot(),
    SecurityAuth0Module.forRoot(configSecurtiy),
    DocumentModule.forRoot(),
    OrderModule.forRoot(),
    EnviromentModule.forRoot(configEnviroment),
    ContainerModule,
    MasterModule,
    NgxSpinnerModule.forRoot({ type: 'square-jelly-box' }),
    NavigationModule,
    PackageModule.forRoot(),
    DeliveryActionsModule.forRoot(),
    ConfigModule.forRoot()
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    // { provide: APP_INITIALIZER, useFactory: fetchBuildDetails, deps: [UpToDateBuildService], multi: true },
  ],
})
export class CoreModule { }
